import React from 'react';
import { BookOpenIcon, ClockIcon, BrainIcon, ShieldIcon, CheckSquareIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function WhatYouGetSection() {
  const deliverables = [{
    icon: BookOpenIcon,
    title: 'El eBook "El Fin del Insomnio por Ansiedad" (PDF)',
    description: 'La guía paso a paso con el método exacto.'
  }, {
    icon: ClockIcon,
    title: 'El Protocolo de los 10 Minutos',
    description: 'Una secuencia ritualista de "apagado" para condicionar tu sueño.'
  }, {
    icon: BrainIcon,
    title: 'Técnica de Vaciado Mental',
    description: 'La plantilla exacta para vaciar tus preocupaciones antes de acostarte.'
  }, {
    icon: ShieldIcon,
    title: 'Guía de Rescate 3 AM',
    description: 'Qué hacer exactamente (y qué NO hacer) si te despiertas a mitad de la noche.'
  }, {
    icon: CheckSquareIcon,
    title: 'Checklist de Habitación Blindada',
    description: 'Cómo convertir tu dormitorio en una fortaleza contra el cortisol.'
  }];
  return <section className="relative z-10 py-24 px-4" data-id="element-153">
      <div className="max-w-6xl mx-auto" data-id="element-154">
        <FadeIn data-id="element-155">
          <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-16" data-id="element-156">
            Lo Que Recibes Hoy
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-157">
          {deliverables.map((item, index) => {
          const Icon = item.icon;
          // Make the first item span full width on tablet, or keep standard grid.
          // We'll use a standard grid but make the first item slightly more prominent.
          const isFirst = index === 0;
          return <FadeIn key={index} delay={index * 0.1} className={`glass-card p-6 flex flex-col ${isFirst ? 'md:col-span-2 lg:col-span-1 bg-blue-900/20 border-blue-500/30' : ''}`} data-id="element-158">
                <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-6 ${isFirst ? 'bg-blue-500/20 text-blue-400' : 'bg-white/10 text-gray-300'}`} data-id="element-159">
                  <Icon className="w-6 h-6" data-id="element-160" />
                </div>
                <h3 className="text-xl font-bold text-white mb-3 font-serif leading-snug" data-id="element-161">
                  {item.title}
                </h3>
                <p className="text-gray-400 flex-grow" data-id="element-162">{item.description}</p>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}